import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

import EmailRow from '@/forms/FormElements/Rows/EmailRow/EmailRow.vue';
import TextRow from '@/forms/FormElements/Rows/TextRow/TextRow.vue';
import FormValidationMixin from '@/forms/FormElements/Mixins/FormValidationMixin';
import Message from '@/forms/Validations/Message';

import getValidation from './NewsletterPopupForm.validations';
import { formNames as names} from '../NewsletterPopup.types'
import NewsletterOptinMixin from '@/forms/FormElements/Mixins/NewsletterOptinMixin';
import CheckBoxRow from '@/forms/FormElements/Rows/CheckBoxRow/CheckBoxRow.vue';
const { validations, model, messages } = getValidation();

@Component({
    validations,
    components: {
      EmailRow,
      TextRow,
      CheckBoxRow,
    }
  })

export default class NewsletterPopupForm extends Mixins(FormValidationMixin, NewsletterOptinMixin) {
    names = names;
    model = model;
    messages: Message[] = messages;

    @Prop()
    readonly ButtonText!: string;

    @Prop()
    readonly BottomText!: string;

    @Prop()
    readonly ShowGate!: boolean;
}